import { Navigate, Outlet, useLocation } from 'react-router-dom';
import { useAuth } from '@/auth/AuthContext';
import { ChangePasswordGate } from './ChangePasswordGate';

export function ProtectedRoute() {
  const { user, passwordChangeRequired, loading } = useAuth();
  const loc = useLocation();

  if (loading) {
    return (
      <div className="min-h-screen grid place-items-center">
        <div className="text-ink-400">Ładowanie…</div>
      </div>
    );
  }
  if (!user) {
    return <Navigate to="/login" state={{ from: loc.pathname + loc.search }} replace />;
  }
  if (passwordChangeRequired) {
    return <ChangePasswordGate />;
  }
  return <Outlet />;
}
